/**
 * Converts a non-empty string (intended to be an email) into a
 * hash; matches the behaviour of Ruby TC::Data::EmailHash
 *
 * If given an empty string, returns null.
 */
export async function emailToHash(email: string): Promise<string | null> {
  if (email == undefined) return null

  const normalised_email = email.toLowerCase().trim()
  if (normalised_email.length == 0) {
    return null
  }

  return "v1:" + (await hashStringSHA256(normalised_email))
}

async function hashStringSHA256(message: string): Promise<string> {
  const msgBuffer = new TextEncoder().encode(message)
  const hashBuffer = await sha256Digest(msgBuffer)
  const hashArray = Array.from(new Uint8Array(hashBuffer))
  const hashHex = hashArray.map((b) => ("00" + b.toString(16)).slice(-2)).join("")
  return hashHex
}

// Method to get a SHA-256 digest independently of being in Nodejs or a browser
async function sha256Digest(message: Uint8Array<ArrayBuffer>): Promise<ArrayBuffer> {
  // This method is available in browsers, but not NodeJS:
  if (globalThis.crypto?.subtle) {
    return globalThis.crypto.subtle.digest("SHA-256", message)
  }

  const nodeCrypto = await import(/* webpackIgnore: true */ "node:crypto")
  if (nodeCrypto?.webcrypto?.subtle) {
    return nodeCrypto.webcrypto.subtle.digest("SHA-256", message)
  }

  throw new Error("No SHA-256 hashing function found")
}
